<template>
  <div
    class="border border-grey shadow-custom-drop-shadow-number rounded-[32px] py-2 px-4 lg:px-24 lg:py-0 gap-10 my-16"
  >
    <div class="flex justify-between items-center space-x-4 mt-4">
      <div class="p-2 text-blue font-semibold">Select Your powerbBall</div>
      <div>
        <button class="flex items-center space-x-1" @click="clearAll">
          <p class="sm:text-base text-sm text-left font-medium text-blue">
            Clear All
          </p>
          <IconBin />
        </button>
      </div>
    </div>
    <hr class="border-t-2 border-gray-300 mt-3" />

    <div class="p-4">
      <div class="flex justify-center space-x-3 my-8">
        <Div class="width-4 flex flex-col items-center">
          <span class="text-blue font-semibold">{{
            selectedNum !== null ? selectedNum.toString().padStart(2, "0") : ""
          }}</span>
          <span class="w-8 h-0.5 bg-customGrey mt-1"></span>
        </Div>
      </div>

      <div
        class="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-9 lg:grid-cols-10 lg:gap-5 sm:gap-6 gap-2 justify-center p-0 sm:p-4 items-center"
      >
        <button
          v-for="num in 20"
          :key="num"
          :class="buttonClass(num)"
          @click="selectNumber(num)"
          class="flex items-center justify-center sm:w-12 sm:h-12 w-10 h-10 rounded-full border border-gray"
        >
          {{ num.toString().padStart(2, "0") }}
        </button>
      </div>
    </div>
    <Div class="gap-2 mt-3 sm:mt-0">
      <button
        class="px-[70px] py-3 bg-white border border-customPink text-customPink rounded-[30px] mb-3 sm:mr-3 mr-1 transition-shadow duration-200 active:shadow-lg"
      >
        Back
      </button>
      <button
          @click="addToCart"
        class="px-[65px] py-3 bg-customPink text-white rounded-[30px] mb-8 mr-1"
        :disabled="selectedNum === null"
        :class="{
          'bg-customPink cursor-pointer transition-shadow duration-200 active:shadow-lg':
            selectedNum,
          'bg-darkGrey  cursor-not-allowed': !selectedNum,
        }"
      >
        Submit
      </button>
    </Div>
  </div>
</template>

<script>
import IconBin from "@/components/IconBin.vue";

export default {
  name: "SelectPowerball",
  components: {
    IconBin,
  },
  data() {
    return {
      selectedNum: null,
    };
  },
  methods: {
    clearAll() {
      this.selectedNum = null;
    },
    selectNumber(num) {
      this.selectedNum = num;
    },
    buttonClass(num) {
      return this.selectedNum === num
        ? "bg-customPink text-white"
        : "bg-paleGrey text-black";
    },
    addToCart()
    {
      this.$emit("clicked",this.selectedNum);
    }
  },
};
</script>

<style scoped></style>
